import type { SupabaseClient } from '@supabase/supabase-js'
import type { Database } from '../db/supabase.types.ts'
import type { FileType } from './uploadTypes.ts'

export type FileBody =
  | ArrayBuffer
  | ArrayBufferView
  | Blob
  | Buffer
  | File
  | FormData
  | NodeJS.ReadableStream
  | ReadableStream<Uint8Array>
  | URLSearchParams
  | string

// Helper to upload image buffer to supabase
export async function uploadFileToSupabase(
  {
    fileBody: buffer,
    filePath,
    bucket = 'property-media',
    type,
  }: {
    fileBody: FileBody
    filePath: string
    bucket: string
    type: FileType
  },
  supabase: SupabaseClient<Database>
) {
  const { data, error } = await supabase.storage.from(bucket).upload(filePath, buffer, {
    contentType: type,
    upsert: false,
  })

  if (error) {
    if (error.name) {
      console.error(error)
      throw new Error(`Supabase upload failed: ${error.message}`)
    }

    return null
  }

  const {
    data: { publicUrl },
  } = supabase.storage.from(bucket).getPublicUrl(data.path)

  return { publicUrl, path: data.path }
}
